import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

import {
  WHITE_SOFT,
  callNoteFieldSx
} from "./dialstack-softphone-widget.styles";
import useCallNote from "./use-call-note.hook";

const STATUS_LABELS = {
  idle: "",
  saving: "Saving…",
  saved: "Saved",
  error: "Could not save"
} as const;

// The phone note on the workbench (ENG-2226): plain text that autosaves to
// the call, for any caller. The hint says where it goes and whether the last
// keystroke has landed.
export default function CallNoteField({
  backendCallId,
  hasPatient
}: {
  backendCallId: number | null;
  hasPatient: boolean;
}) {
  const { text, status, setText } = useCallNote(backendCallId);
  if (backendCallId === null) return null;
  return (
    <Box data-testid="call-note-field" sx={callNoteFieldSx}>
      <TextField
        multiline
        minRows={2}
        maxRows={5}
        fullWidth
        size="small"
        placeholder="Phone note for this call…"
        value={text}
        onChange={(event) => setText(event.target.value)}
        className="suno-phone-no-drag"
        inputProps={{ "aria-label": "Phone note", maxLength: 20000 }}
      />
      <Typography
        component="div"
        data-testid="call-note-status"
        sx={{
          mt: 0.5,
          display: "flex",
          justifyContent: "space-between",
          fontSize: 12,
          // On the plum body, like the bar's fact line; amber for a failed save.
          color: status === "error" ? misc.lightYellow : WHITE_SOFT
        }}
      >
        <span>
          {hasPatient
            ? "Saves to this call and the patient's chart"
            : "Saves to this call"}
        </span>
        <span aria-live="polite">{STATUS_LABELS[status]}</span>
      </Typography>
    </Box>
  );
}
